<div class="fx-link-control-user-history card bg-dark-lighter text-white">
  <div class="card-body">
    <div class="row">
      <div class="col fs-16 mb-3">
        <span class="text-red">{{ "User - " }}</span>
        <span>{{ "Affiliate list" }}</span>
      </div>
    </div>
    <div class="p-15">
      <div class="row mb-15">
        <div class="col-md-6 col-xs-12">
          <div class="input-group search-group">
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              [(ngModel)]="keyword"
              (keyup)="search($event)"
              placeholder="Search"
            />
            <button class="btn btn-main" type="button" (click)="search(null)">
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive">
            <table class="rox-table table-bordered bg-dark">
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">Campaign name</th>
                  <th class="text-center">Created date</th>
                  <th class="text-center">MT5 Group</th>
                  <th class="text-center">Is Default Link</th>
                  <th class="text-center">Clicks</th>
                  <th class="text-center">Registered account</th>
                  <th class="text-center" *ngIf="permission.allowCreating">
                    Link Affiliate
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of listTrades
                      | paginate
                        : {
                            id: 'link-trader',
                            itemsPerPage: pageInfo.pageSize,
                            currentPage: pageInfo.pageIndex,
                            totalItems: pageInfo.totalRecord
                          };
                    let i = index
                  "
                >
                  <td class="text-center">{{ item.trader_campaign_id }}</td>
                  <td class="text-center">{{ item.description }}</td>
                  <td class="text-center">
                    {{ item.create_time | date: "yyyy/MM/dd" }}
                  </td>
                  <td class="text-center">
                    <mat-select [(ngModel)]="item.data[0].group_config_id">
                      <mat-option *ngFor="let group of item.data" [value]="group.group_config_id">
                        <span labelGroup="{{group.group_name}}"></span>
                      </mat-option>
                    </mat-select>
                  </td>
                  <td class="text-center">{{ item.is_default ? item.is_default === 1 ? 'Yes' : 'No' : 'No' }}</td>
                  <td class="text-center">
                    {{ item.total_click }}
                  </td>
                  <td class="text-center">
                    {{ item.total_user }}
                  </td>
                  <td class="text-center" *ngIf="permission.allowCreating">
                    <button
                      class="btn btn-info rounded m-1"
                      fx-copy="{{ item.url + '?refer=' + item.code }}"
                    >
                      {{ "Copy" | translate }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="link-trader"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
